/**
 * Datas do cadastro de instalação com inflamáveis. As datas viajam como texto `YYYY-MM-DD` e a conta
 * de dias sai delas sem passar por `Date` com hora, que deslocaria o dia pelo fuso.
 */

/** `2026-11-30` → `30/11/2026`. */
export const formatarData = (iso: string): string => {
  const [ano, mes, dia] = iso.slice(0, 10).split('-');
  return `${dia}/${mes}/${ano}`;
};

const MS_POR_DIA = 24 * 60 * 60 * 1000;

const diaDeCalendario = (iso: string): number => {
  const [ano, mes, dia] = iso.slice(0, 10).split('-').map(Number);
  return Date.UTC(ano, mes - 1, dia);
};

/** O dia de hoje, no calendário de quem está com a tela aberta, em `YYYY-MM-DD`. */
export const hojeComoTexto = (agora: Date = new Date()): string => {
  const mes = String(agora.getMonth() + 1).padStart(2, '0');
  const dia = String(agora.getDate()).padStart(2, '0');
  return `${agora.getFullYear()}-${mes}-${dia}`;
};

/**
 * Dias entre hoje e a data de vencimento (negativo = vencido). O resumo do servidor não traz dias
 * por item, então o `ValidityChip` recebe a conta feita aqui a partir das datas que ele traz.
 */
export const diasAteVencer = (vencimento: string, hoje: string = hojeComoTexto()): number =>
  Math.round((diaDeCalendario(vencimento) - diaDeCalendario(hoje)) / MS_POR_DIA);
